// import React, { useState } from 'react'
// import RadioButton from './RadioButton'
// import style from "../styles/Question.css"

// export default function Question(props) {
//     // const [selectedOption, setSelectedOption] = useState(null);

//     const handleOptionChange = (event) => {
//     //   setSelectedOption(event.target.value);
//       props.onAnswerSelected(event.target.value, props.id);
//     };

//     return (
//         <div className="card bg-light mb-3" >
//             <div className="card-header"><b>Question {props.id +1}</b></div>
//             <div className="card-body">
//                 <h5 className="card-title">{props.question.question}</h5>
//                 <div className="card-text">
//                     <RadioButton option={"A. "+props.question.options[0]} num="1" name={props.id} handleOptionChange={handleOptionChange} required/> 
//                     <RadioButton option={"B. "+props.question.options[1]} num="2" name={props.id} handleOptionChange={handleOptionChange} required/> 
//                     <RadioButton option={"C. "+props.question.options[2]} num="3" name={props.id} handleOptionChange={handleOptionChange} required/> 
//                     <RadioButton option={"D. "+props.question.options[3]} num="4" name={props.id} handleOptionChange={handleOptionChange} required/> 
//                 </div>
//             </div>
//         </div>
//     )
// }
import React, { useState, useEffect } from 'react';
import RadioButton from './RadioButton';
import '../styles/Question.css';

export default function Question(props) {
  const [selectedOption, setSelectedOption] = useState(props.selectedAnswer || "0");

  // Update local state when props change
  useEffect(() => {
    if (props.selectedAnswer) {
      setSelectedOption(props.selectedAnswer);
    }
  }, [props.selectedAnswer]);

  const handleOptionChange = (event) => {
    const value = event.target.value;
    // console.log(`Question ${props.id + 1}: Option ${value} selected`); // Debug log
    setSelectedOption(value);
    props.onAnswerSelected(value, props.id);
  };

  return (
    <div className="question-card">
      <div className="question-header">
        <span className="question-number">प्रश्न {props.id + 1}</span>
        {selectedOption !== "0" && (
          <span className="selected-indicator">✓ उत्तर निवडले</span>
        )}
      </div>
      
      <div className="question-body">
        <h5 className="question-title">{props.question.question}</h5>
        
        <div className="options-container">
          <RadioButton 
            option={"A. " + props.question.options[0]} 
            num="1" 
            name={`question_${props.id}`}
            handleOptionChange={handleOptionChange}
            checked={selectedOption === "1"}
            required
          /> 
          
          <RadioButton 
            option={"B. " + props.question.options[1]} 
            num="2" 
            name={`question_${props.id}`}
            handleOptionChange={handleOptionChange}
            checked={selectedOption === "2"}
            required
          /> 
          
          <RadioButton 
            option={"C. " + props.question.options[2]} 
            num="3" 
            name={`question_${props.id}`}
            handleOptionChange={handleOptionChange}
            checked={selectedOption === "3"}
            required
          /> 
          
          <RadioButton 
            option={"D. " + props.question.options[3]} 
            num="4" 
            name={`question_${props.id}`}
            handleOptionChange={handleOptionChange}
            checked={selectedOption === "4"}
            required
          /> 
        </div>
      </div>
    </div>
  );
}